module.exports = __webpack_public_path__ + "media/recipes/63-27c65ca2.png";